import Api from "@/api/index";
import loading from "./loading";
import store from "@/store";
import confirmations from "./confirmations";
import AuthenticationService from "@/services/AuthenticationService";
import alerts from "@/alerts/alert";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const jenis_iuran = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    form: [],
    queryParam: {},
    loading: false,
    modalCreate: false,
    modalDetail: false,
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },

    SET_FORM(state, datas) {
      state.form = datas;
    },
    SET_MODAL_CREATE(state, datas) {
      state.modalCreate = datas;
    },
    SET_MODAL_DETAIL(state, datas) {
      state.modalDetail = datas;
    },
  },
  actions: {
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("globals/param/iuran/page", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doPaginate("globals/param/iuran").then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
    async onRefresh({ state }) {
      store.dispatch("iuran/paginate", state.queryParam);
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      }
    },
    closeModalCreate({ commit }) {
      commit("SET_MODAL_CREATE", false);
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `iuran/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.post("iuran", payload)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("iuran/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default jenis_iuran;
